import { clsx } from "clsx";
import { useTranslations } from "../../i18n";
import { Text } from "../Text";
import { useSelectContext } from "./context";
import { SelectItem } from "./SelectItem";

export const SelectContent = () => {
  const { t } = useTranslations();
  const { options, contentClassName, maxHeight } = useSelectContext();
  return (
    <div
      className={clsx(`nuco-select__content`, contentClassName)}
      role="presentation"
      style={{ maxHeight }}
    >
      {options.map((option, index) => {
        return <SelectItem key={option.id} option={option} index={index} />;
      })}

      {options.length === 0 && (
        <div className="nuco-select__content-emptyState">
          <Text>{t("ui.select.noResults")}</Text>
        </div>
      )}
    </div>
  );
};
